import React from 'react';

export default function MitarbeiterPending() {
  return (
    <div className="p-8 text-center text-primary mt-20">
      <h2 className="text-2xl font-bold">Account wird geprüft</h2>
      <p className="text-muted-foreground mt-4">Ihr Tester-Account wird aktuell von einem Admin verifiziert.</p>
    </div>
  );
}